import { memo } from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import { fadeTop } from 'styles/animations';
import styled from 'styled-components';
import { device } from 'styles/breakpoints';

const AnimateTop = ({ children, y = '100%' }) => {
  return (
    <motion.div
      variants={fadeTop}
      initial={{
        ...fadeTop.hidden,
        y: y,
      }}
      animate='visible'
    >
      <Container>{children}</Container>
    </motion.div>
  );
};

AnimateTop.propTypes = {
  children: PropTypes.node.isRequired,
  y: PropTypes.string || PropTypes.number,
};

const Container = styled.div`
  width: 100%;
  max-width: 745px;
  @media ${device.tablet} {
    max-width: 300px;
    padding: 0 15px;
  }
`;

export default memo(AnimateTop);
